<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.truck.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{$t('string.msg.truck.search.description')}}
                </p>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.manufacturs.label')}}
                            </label>
                            <select id="manufacturer" v-model="filters.manufacturer" class="form-control">
                                <option value="" selected>{{$t('string.msg.select.selector.item')}}</option>
                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.plate.label')}}
                            </label>
                            <input type="text" onkeyup="this.value = this.value.toUpperCase();" v-model="filters.plate" class="form-control" v-mask="['AAA #X##']" :placeholder="$t('string.msg.truck.register.placeholder.plate')">
                            
                        </div>                        

                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.trucker.label')}}
                            </label>
                            <autocomplete
                                :search="onChangeName"
                                :get-result-value="getResultValue"
                                @submit="submitFilter"
                                debounceTime="500"
                            ></autocomplete>
                        </div>
                    </div>

                    <!--<div class="form-row">

                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.truck.register.label.company.and.trucker')}}                                
                            </label>
                            <input type="text" v-model="filters.truckerName" class="form-control">
                        </div>

                    </div>-->

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                        <!--<button @click="clearFilter" type="button" class="btn btn-warning w-20">Limpar filtro</button>-->
                        
                        <download-excel v-if="items.length>0"
                            class   = "btn btn-primary"
                            :fetch   = "fetchData"
                            :fields = "json_fields"
                            :meta = "json_meta"
                            type    = "csv"
                            name    = "trucks-geral.xls">
                            Download CSV
                        </download-excel>
                    </div>
                    
                </form>
                  <div class="pb-0 pt-3 ">
                        <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                </div>
                <div id="vue-table">
                    <div class="table-responsive">
                        <table class="table table-centered table-hover mb-0" id="datatable">
                            <thead>
                                <tr>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.manufacture')}}</th> 
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.model')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.year')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.Placa')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.group')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.trucktrailer.table.header.owner')}}</th>
                                </tr>
                            </thead>
                            <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                <tr v-if="item && item.status == 'ACTIVE'">
                                    <td>
                                        <span>
                                            {{item.manufacturer.name}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.model && item.model.name">
                                            {{item.model.name}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{item.year}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>   
                                            {{item.plate}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.truckTrailers.length > 0">   
                                            {{$t('string.msg.truck.table.text.yes')}}
                                        </span>
                                        <span v-else>
                                            {{$t('string.msg.truck.table.text.no')}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.truckDriver">   
                                            {{camelize(item.truckDriver.firstName) + ' ' + camelize(item.truckDriver.lastName)}}
                                        </span>
                                    </td>
                             
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListTruck';
import Toast from '../../../components/layout/Toast';
import Spinner from '../../../components/layout/Spinner';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.prototype.$eventHub = new Vue();
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel);

export default {
  name: 'ListTruck',
  props: ["valuekey"],

  components: {
    Toast
  },
 
  data() {
      return {
        PageNumbers:1,
        pageOfItems: [],
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        certifies:[],
        manufacturers: [],
        truckerName: null,
        filters: {
            manufacturer: null,
            company: null,
            plate:null,
            status: 'ACTIVE',
            truckerName: null,
            vehicleTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK",
                "TRUCK_MECHANICAL_HORSE_SIMPLE",
                "TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO",
                "TRUCK_DOUBLE_TRAIN","TRUCK_RODOTREM"]
        },
           json_fields: {
            'Tipo': 'vehicleType',   
            'Fabricante': 'manufacturer.name',
            'Modelo': 'model.name',
            'Ano de Fabricacao': 'year',
            'Ano do Modelo': 'yearModel',
            'Placa': 'plate',
            'KM Atual': 'actualKM',
            'Tracao': 'traction',
            'RENAVAM': 'renavam',
            'Chassi': 'chassi',
            'Cor': 'color',
            'PBT': 'pbt',
            'Nome Proprietario': 'truckDriver.firstName',
            'Sobrenome Proprietario': 'truckDriver.lastName',
            'E-mail Proprietario': 'truckDriver.email',
            'Telefone Proprietario': 'truckDriver.primaryPhone',
            'CPF Proprietario': 'truckDriver.customerUser.document',
            'CNH Proprietario': 'truckDriver.customerUser.cnh',
            'Certificados':  'certifies.certified.name',
        },
        json_data: [
            {
                vehicleType: null,
                manufacturer:{
                    name: null
                },
                model:{
                    name:null
                },
                year: null,
                yearModel: null,
                plate: null,
                actualKM: null,
                traction: null,
                renavam: null,
                chassi: null,
                color: null,
                pbt: null,
                truckDriver:{
                    firstName: null,
                    lastName: null,
                    email: null,
                    primaryPhone: null,
                    customerUser:{
                        document: null,
                        cnh: null,
                    }
                },
                certifies:[{
                    certified:{
                        name: null
                    }
                }]  
            },  
        ],
        json_meta: [
			[{
				"key": "charset",
				"value": "utf-8"
			}]
		],
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
  }

}
</script>

<style>
</style>
